import type { ComponentProps } from "react";

import { cn } from "@/lib/helpers/cn";

type HeadingProps = {
  as?: HeadingTag;
  size?: 1 | 2 | 3 | 4 | 5; // smallest to largest
} & ComponentProps<HeadingTag>;

type HeadingTag = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

export function Heading2({ as, children, className, size = 3, ...props }: HeadingProps) {
  const Body = as ?? "h2";

  return (
    <Body className={cn("tw:text-text-primary tw:mb-0!", `heading-${size}`, className)} {...props}>
      {children}
    </Body>
  );
}
